<template>
  <v-card height="calc(100vh - 40px)" title="Machine Search">
    <template #append>
      <v-btn @click="emit('cancel')">Close</v-btn>
    </template>
    <v-card-text>
      <v-row>
          <v-col>
              <v-text-field
                v-model="name"
                label="Search" />
          </v-col>
          <v-col>
            <v-autocomplete
            variant="outlined"
              clearable
              chips
              label="Category"
              :items="categories"
              multiple
              v-model="category"></v-autocomplete>
          </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-data-table
            :headers="headers"
            :items="filteredMachines">
            <template #item="{ item }">
              <tr >
                <td>{{ item.name }}</td>
                <!-- <td>{{ item.id_number_machine }}</td> -->
                <td>
                    <v-btn @click="activeMachine = item.id">Details</v-btn>
                    <v-btn @click="$emit('select', item.id)">Auswählen</v-btn>
                </td>
                <td>{{ item.category_machine }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
        <v-col
          cols="8"
          v-if="activeMachine !== null">
          <MachineView
            :machine="mainStore.machineDb[activeMachine]"
            :search="true"
            @select="$emit('select', activeMachine)" />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
import MachineView from "@/views/BaseData/DatabaseMachine/MachineView.vue";
import { useMainStore } from "@/stores/mainStore";
import { useTranslation } from "i18next-vue";
import { computed, Ref, ref } from "vue";
const { t } = useTranslation();

const headers = [
  { title: t("entities.machine.name"), value: "name" },
  {
    title: "Aktionen"//t("entities.machine.fields.id_number_machine"),
    // value: "id_number_machine"
  },
  { title: "Kategorie" }
];

const emit = defineEmits(["select", "cancel"]);

const categories = computed(() => {
  return [...new Set(mainStore.machines.map((i) => i.category_machine).filter((i) => i !== "")), "Keine Kategorie"];
});

const name = ref("");
const category: Ref<string[]> = ref([]);

const filteredMachines = computed(() => {
  let result = mainStore.machines;
  if (name.value) {
    result = result.filter((i) => i.name.includes(name.value));
  }
  if (category.value.length) {
    result = result.filter((i) => category.value.includes(i.category_machine) || (category.value.includes("Keine Kategorie") ? !i.category_machine : false));
  }
  return result;
});

const mainStore = useMainStore();
const activeMachine = ref<string | null>(null);
</script>
